<template>
  <div class="container page">
    <van-nav-bar title="News board" class="nav-bar">
    </van-nav-bar>

    <div class="main-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="No more data"
        @load="onLoad"
      >
        <div class="message-item" v-for="(item, index) in list" :key="index">
          <div class="message-date">{{ item.date }}</div>
          <div class="message-id">{{ item.name }}</div>
          <div class="message-content">{{ item.content }}</div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onLoad() {
      this.getMessageList();
    },
    getMessageList() {
      this.$http({
        method: 'get',
        url: 'user_get_message_board',
        params: {
          page: this.page
        }
      }).then(res => {
        if (res.code === 200) {
          this.list = [...this.list, ...res.data];
          this.loading = false;
          if (res.data.current_page >= res.data.last_page) {
            this.finished = true;
          } else {
            this.page++;
          }
        } else {
          this.loading = false;
          this.finished = true;
        }
      }).catch(() => {
        this.loading = false;
        this.finished = true;
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.page {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 1.6rem;
}

.nav-bar {
  background-color: #fff;
}

::v-deep .van-nav-bar__title {
  color: #333;
  font-size: 0.48rem;
}

.main-content {
  padding: 0.26667rem;
}

.message-item {
  background: #fff;
  border-radius: 0.2rem;
  padding: 0.4rem;
  margin-bottom: 0.26667rem;
  border: 1px solid #ddd;
}

.message-date {
  font-size: 0.25rem;
  color: #000;
  margin-bottom: 0.15rem;
  font-weight: 700;
}

.message-id {
  font-size: 0.3667rem;
  color: #999;
  margin-bottom: 0.3rem;
}

.message-content {
  font-size: 0.3rem;
  color: #000;
  line-height: 1.6;
  font-weight: 700;
}

::v-deep .van-list__finished-text {
  font-size: 0.32rem;
  color: #999;
}
</style>
